import React from 'react';
import {connect} from 'react-redux';

import {AppState} from "@Redux/store";
import {Dispatch} from "@Redux/type";
import OrganisationsView from "@Builder/myArmyList/make/unit/show/OrganisationView";
import ModelRuleAndRuleView from "@Builder/myArmyList/make/unit/show/ModelRuleAndRuleView";
import Repeater from "@Utils/Repeater";
import {TroopProfilView} from "@Selectors/builder/myArmyList/make/unit/show/view/ArmyListUnitProfilV2View";
import {Field, FieldArray, InjectedFormProps, reduxForm, WrappedFieldArrayProps} from "redux-form";
import validate, {NinthAgeUnitV2MakeParams} from "./NinthAgeUnitV2MakeValidate";
import {CardBody, Col, Row} from "reactstrap";
import ReduxFormSmallInput from "@Utils/ReduxFormSmallInput";
import {Form} from "./NinthAgeUnitV2MakeForm.styled";
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';

interface Props {
  onSubmit: (values: NinthAgeUnitV2MakeParams) => void
}

const FormComponent: React.FC<FormProps & InjectedFormProps<NinthAgeUnitV2MakeParams, FormProps>> = ({
                                                                                                       unit,
                                                                                                       handleSubmit
                                                                                                     }) => {

  const renderTroops = ({fields, meta: {error}}: WrappedFieldArrayProps<any>) => {
    if (fields.length === 0) {
      return <></>
    }

    return <>
      {fields.map((item, index) => (<tr key={`troop-${index}`}>
        <td>{fields.get(index).name}</td>
        <td className="text-center">
          <label htmlFor="carac.att" className="sr-only">Att</label>
          <Field
            id="att"
            name={`${item}.att`}
            type="text"
            component={ReduxFormSmallInput}
            placeHolder={'tool.survey.unit.carac.att'}
          />
        </td>
        <td className="text-center">
          <label htmlFor="carac.of" className="sr-only">Of</label>
          <Field
            id="carac.of"
            name={`${item}.of`}
            type="text"
            component={ReduxFormSmallInput}
            placeHolder={'tool.survey.unit.carac.of'}
          />
        </td>
        <td className="text-center">
          <label htmlFor="carac.str" className="sr-only">Str</label>
          <Field
            id="carac.str"
            name={`${item}.str`}
            type="text"
            component={ReduxFormSmallInput}
            placeHolder={'tool.survey.unit.carac.str'}
          />
        </td>
        <td className="text-center">
          <label htmlFor="carac.ap" className="sr-only">Ap</label>
          <Field
            id="carac.ap"
            name={`${item}.ap`}
            type="text"
            component={ReduxFormSmallInput}
            placeHolder={'tool.survey.unit.carac.ap'}
          />
        </td>
        <td className="text-center">
          <label htmlFor="carac.agi" className="sr-only">Agi</label>
          <Field
            id="carac.agi"
            name={`${item}.agi`}
            type="text"
            component={ReduxFormSmallInput}
            placeHolder={'tool.survey.unit.carac.agi'}
          />
        </td>
        <td className="d-none d-md-block">
          <ModelRuleAndRuleView armyListUnitId={''} modelRules={fields.get(index).modelRules}/>
        </td>
      </tr>
    ))}
      {error && <div className="error">{error}</div>}
    </>
  }

  const renderOptions = ({fields, meta: {error}}: WrappedFieldArrayProps<any>) => {
    if (fields.length === 0) {
      return <></>
    }

    return <Col xs={12} md={4} className="options">
      {fields.map((item, index) => (
        <div className="input-group" key={`${fields.name}-${index}`}>
          <div className="input-group-prepend">
            <span className="input-group-text" id="basic-addon3">{fields.get(index).name}</span>
          </div>
          <label htmlFor="points" className="sr-only">Points</label>
          <Field
            id="points"
            name={`${item}.points`}
            type="text"
            component={ReduxFormSmallInput}
            placeHolder={'tool.survey.unit.options.points'}
          />
          <div className="input-group-append">
            <span className="input-group-text" id="basic-addon3">pts</span>
          </div>
        </div>
      ))}
      {error && <div className="error">{error}</div>}
    </Col>
  }

  return (
    <Form onSubmit={handleSubmit}>
      <CardBody>
        <Row className="mt-2">
          <Col xs={12} md={4}>
            <OrganisationsView organisations={unit.organisations}/>
            <h2 className={'clear-none'}>{unit.name}</h2>
            <Row>
              <Col className="input-group justify-content-end">
                <label htmlFor="points" className="sr-only">Points</label>
                <Field
                  id="points"
                  name="points"
                  type="number"
                  min={0}
                  max={1000}
                  step={1}
                  component={ReduxFormSmallInput}
                  placeHolder={'tool.survey.unit.points'}
                />
                <div className="input-group-append">
                  <span className="input-group-text" id="basic-addon2">pts</span>
                </div>
              </Col>
              <Col className="input-group">
                <label htmlFor="addPoints" className="sr-only">Points</label>
                <div className="input-group-prepend">
                  <span className="input-group-text" id="basic-addon3">+</span>
                </div>
                <Field
                  name="addPoints"
                  type="number"
                  min={0}
                  max={1000}
                  step={1}
                  component={ReduxFormSmallInput}
                  placeHolder={'tool.survey.unit.add_points'}
                />
                <div className="input-group-append">
                  <span className="input-group-text">pts/extra model</span>
                </div>
              </Col>
            </Row>
          </Col>
          <Col xs={12} md={4}>
            Size:
            <Row>
              <Col className="input-group justify-content-end">
                <label htmlFor="sizeMin" className="sr-only">Min Size</label>
                <Field
                  id="sizeMin"
                  name="sizeMin"
                  type="number"
                  min={1}
                  max={1000}
                  step={1}
                  component={ReduxFormSmallInput}
                  placeHolder={'tool.survey.unit.size_min'}
                />
                <div className="input-group-append">
                  <span className="input-group-text" id="basic-addon2">min -</span>
                </div>
              </Col>
              <Col className="input-group">
                <label htmlFor="addPoints" className="sr-only">Size Max</label>
                <Field
                  name="sizeMax"
                  type="number"
                  min={1}
                  max={1000}
                  step={1}
                  component={ReduxFormSmallInput}
                  placeHolder={'tool.survey.unit.size_max'}
                />
                <div className="input-group-append">
                  <span className="input-group-text">max</span>
                </div>
              </Col>
            </Row>
          </Col>
          <Col xs={12} md={4}>
            <ul className={'list-inline mb-1 text-center'}>
              <li className={'list-inline-item'}><span className="text-italic">Size:</span> {unit.carac.height}</li>
              <li className={'list-inline-item'}><span className="text-italic">Type:</span> {unit.carac.unitType}</li>
              <li className={'list-inline-item'}><span className="text-italic">Base:</span> {unit.carac.base}</li>
            </ul>
          </Col>
          <Col xs={12}>
            <table className="content-stats stats-v2 stats-global">
              <thead>
              <tr>
                <th scope="col">Global</th>
                <th scope="col" className="text-center">Adv</th>
                <th scope="col" className="text-center">Mar</th>
                <th scope="col" className="text-center">Dis</th>
                <th scope="col" className="text-center">Evoked</th>
                <th scope="col"/>
                <th scope="col"/>
                <th scope="col" className="d-none d-md-block">Model Rules</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td/>
                <td className="text-center">
                  <label htmlFor="carac.adv" className="sr-only">Adv</label>
                  <Field
                    id="carac.adv"
                    name="carac.adv"
                    type="text"
                    component={ReduxFormSmallInput}
                    placeHolder={'tool.survey.unit.carac.adv'}
                  />
                </td>
                <td className="text-center">
                  <label htmlFor="carac.mar" className="sr-only">Mar</label>
                  <Field
                    id="carac.mar"
                    name="carac.mar"
                    type="text"
                    component={ReduxFormSmallInput}
                    placeHolder={'tool.survey.unit.carac.mar'}
                  />
                </td>
                <td className="text-center">
                  <label htmlFor="carac.dis" className="sr-only">Dis</label>
                  <Field
                    id="carac.dis"
                    name="carac.dis"
                    type="text"
                    component={ReduxFormSmallInput}
                    placeHolder={'tool.survey.unit.carac.dis'}
                  />
                </td>
                <td className="text-center">
                  <label htmlFor="carac.evoked" className="sr-only">Evoked</label>
                  <Field
                    id="carac.evoked"
                    name="carac.evoked"
                    type="text"
                    component={ReduxFormSmallInput}
                    placeHolder={'tool.survey.unit.carac.evoked'}
                  /></td>
                <td/>
                <td/>
                <td className="d-none d-md-block">
                  <ModelRuleAndRuleView armyListUnitId={''} modelRules={unit.modelRules}/>
                </td>
              </tr>
              {unit.carac.fly &&
                <tr>
                  <td>Fly</td>
                  <td>
                    <label htmlFor="carac.fly.adv" className="sr-only">Fly Adv</label>
                    <Field
                      id="carac.fly.adv"
                      name="carac.fly.adv"
                      type="text"
                      component={ReduxFormSmallInput}
                      placeHolder={'tool.survey.unit.carac.fly.adv'}
                    />
                  </td>
                  <td>
                    <label htmlFor="carac.fly.mar" className="sr-only">Fly mar</label>
                    <Field
                      id="carac.fly.mar"
                      name="carac.fly.mar"
                      type="text"
                      component={ReduxFormSmallInput}
                      placeHolder={'tool.survey.unit.carac.fly.mar'}
                    />
                  </td>
                  <td/>
                  <td colSpan={3}/>
                  <td className="d-none d-md-block">
                  </td>
                </tr>}
              </tbody>
            </table>
            <div className="d-block d-md-none content-stats">
              <ModelRuleAndRuleView armyListUnitId={''} modelRules={unit.modelRules}/>
            </div>
          </Col>
          <Col xs={12}>
            <table className="content-stats stats-v2 stats-defensive">
              <thead>
              <tr>
                <th scope="col">Defensive</th>
                <th scope="col" className="text-center">Hp</th>
                <th scope="col" className="text-center">Def</th>
                <th scope="col" className="text-center">Res</th>
                <th scope="col" className="text-center">Arm</th>
                <th scope="col" className="text-center">Aeg</th>
                <th scope="col" className="d-none d-md-block"/>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td/>
                <td className="text-center">
                  <label htmlFor="carac.hp" className="sr-only">Hp</label>
                  <Field
                    id="carac.hp"
                    name="carac.hp"
                    type="text"
                    component={ReduxFormSmallInput}
                    placeHolder={'tool.survey.unit.carac.hp'}
                  />
                </td>
                <td className="text-center">
                  <label htmlFor="carac.def" className="sr-only">Def</label>
                  <Field
                    id="carac.def"
                    name="carac.def"
                    type="text"
                    component={ReduxFormSmallInput}
                    placeHolder={'tool.survey.unit.carac.def'}
                  />
                </td>
                <td className="text-center">
                  <label htmlFor="carac.res" className="sr-only">Res</label>
                  <Field
                    id="carac.res"
                    name="carac.res"
                    type="text"
                    component={ReduxFormSmallInput}
                    placeHolder={'tool.survey.unit.carac.res'}
                  />
                </td>
                <td className="text-center">
                  <label htmlFor="carac.arm" className="sr-only">Arm</label>
                  <Field
                    id="carac.arm"
                    name="carac.arm"
                    type="text"
                    component={ReduxFormSmallInput}
                    placeHolder={'tool.survey.unit.carac.arm'}
                  />
                </td>
                <td className="text-center">
                  <label htmlFor="carac.aeg" className="sr-only">Aeg</label>
                  <Field
                    id="carac.aeg"
                    name="carac.aeg"
                    type="text"
                    component={ReduxFormSmallInput}
                    placeHolder={'tool.survey.unit.carac.aeg'}
                  />
                </td>
                <td className="d-none d-md-block">
                  <ModelRuleAndRuleView armyListUnitId={''} modelRules={unit.modelRules}/>
                </td>
              </tr>
              </tbody>
            </table>
            <div className="d-block d-md-none content-stats">
              <ModelRuleAndRuleView armyListUnitId={''} modelRules={unit.modelRules}/>
            </div>
          </Col>
          <Col xs={12}>
            <table className="content-stats stats-v2 stats-offensive">
              <thead>
              <tr>
                <th scope="col">Offensive</th>
                <th scope="col" className="text-center">Att</th>
                <th scope="col" className="text-center">Of</th>
                <th scope="col" className="text-center">Str</th>
                <th scope="col" className="text-center">Ap</th>
                <th scope="col" className="text-center">Agi</th>
                <th className="d-none d-md-block"/>
              </tr>
              </thead>
              <tbody>
              <FieldArray name="troops" component={renderTroops}/>
              </tbody>
            </table>
            <div className="d-block d-md-none content-stats">
              <Repeater data={unit.troops} indexPrefix='troop'>
                {
                  (item: TroopProfilView) =>
                    <div>
                      {item.name}
                      <ModelRuleAndRuleView armyListUnitId={''} modelRules={item.modelRules}/>
                    </div>
                }
              </Repeater>
            </div>
          </Col>
          <FieldArray name="magics" component={renderOptions}/>
          <FieldArray name="options" component={renderOptions}/>
          <FieldArray name="mounts" component={renderOptions}/>

          <Col className="mt-3">
            <button className="btn btn-age btn-lg m-3 center-btn">{<FormattedMessage {...defaultMessages.formValidate} />}</button>
          </Col>
        </Row>
      </CardBody>
    </Form>
  )

};

const NinthAgeUnitV2MakeForm = reduxForm<NinthAgeUnitV2MakeParams, FormProps>({
  form: 'survey_ninth_age_unit_v2', // a unique identifier for this form
  validate,
})(FormComponent);

const mapStateToProps = (state: AppState, props: any) => ({
  initialValues: {
    points: 100,
    addPoints: 25,

    sizeMin: 1,
    sizeMax: 10,

    carac: {

      adv: 'adv',
      mar: 'mar',
      dis: 'dis',
      evoked: 'evoked',
      hp: 'hp',
      def: 'def',
      res: 'res',
      arm: 'arm',
      aeg: 'aeg',
      fly: {
        adv: 'fadv',
        mar: 'fmar',
      },
    },

    troops: [
      {
        id: 1,
        name: 'Troop name',
        att: 'Att',
        of: 'Of',
        str: 'Str',
        ap: 'Ap',
        agi: 'Agi',
        modelRules: [],
      },
    ],

    magics: [
      {id: 1, name: 'Wizard', points: 50},
    ],
    options: [
      {id: 2, name: 'Shield', points: 5},
    ],
    mounts: [
      {id: 3, name: 'Horse', points: 10},
    ],
  },
  unit: {
    name: 'Unit name',
    organisations: [],
    carac: {
      fly: null,
      height: 'Large',
      unitType: 'Infantry',
      base: '20x20',
    },
    troops: [],
    modelRules: [],
  }
})

const mapDispatchToProps = (dispatch: Dispatch) => ({})


type FormProps = Props &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>

export default connect(mapStateToProps, mapDispatchToProps)(NinthAgeUnitV2MakeForm);
